
import router from "@/router";
import { defineComponent, onUpdated, reactive, ref } from "vue";

export default defineComponent({
  name: "Page Frame",
  props: {
    modelValue: {
      type: Number,
      required: false,
    },
    isClose: {
      type: Boolean,
      default: false,
    },
  },
  setup(props /*{ emit }*/) {
    const currentPage = ref(props.modelValue ?? 0);

    const close = () => {
      router.back();
    };

    const state = reactive({
      isClose: props.isClose,
    });

    onUpdated(() => {
      if (currentPage.value === props.modelValue) return;
      else currentPage.value = props.modelValue ?? 0;
    });

    return { close, state };
  },
  components: {},
});
